import { Box, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { change } from "../state/Nav";

import { LayoutState, MediaQueryLinebreak, MediaQueryMobile, MediaQueryShallow } from "../Layout";
import { hideKrpano } from "../Util";

export default function Home() {
    // Init layout parameters
    const layoutState = new LayoutState();
    layoutState.isMobile = useMediaQuery(MediaQueryMobile);
    layoutState.linebreak = useMediaQuery(MediaQueryLinebreak);
    layoutState.isShallow = useMediaQuery(MediaQueryShallow);

    // Counter for picture iterator
    const [count, setCount] = useState(0);

    // Set navigation to current component
    const dispatch = useDispatch();
    if (count === 0) {
        dispatch(change("home"));
    }

    // Hide virtual tour
    hideKrpano();

    // Increment counter after interval
    useEffect(() => {
        const tick = setInterval(() => { setCount(count + 1) }, 3000);
        return () => {
            clearInterval(tick);
        }
    });

    // Calculate image number as counter modulo 10
    const imgNr = ((count % 10) + 1).toString();
    
    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "30px", paddingTop: layoutState.HomePaddingTop() }}>
            <img src={"/img/large/kr" + imgNr + ".png"} style={{ objectFit: "contain", marginLeft: "auto", marginRight: "auto", maxHeight: layoutState.HomeImageHeight(), width: layoutState.HomeImageWidth() }} />    
        </Box>
    );
}